import { render, staticRenderFns } from "./HazmatModal.vue?vue&type=template&id=563aabc6&scoped=true"
import script from "./HazmatModal.vue?vue&type=script&lang=js"
export * from "./HazmatModal.vue?vue&type=script&lang=js"
import style0 from "./HazmatModal.vue?vue&type=style&index=0&id=563aabc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563aabc6",
  null
  
)

export default component.exports